import { postAppEvent } from "../services/appEvent";
import { addQueryParams } from "./addQueryParams";
import { handleQuizSubmit } from "./customEvent";
import fetchCustomRedirectionIfAny from "./fetchCustomRedirection";

const quizRedirect = (respId: string, sessionId: string, quiz: object, pageUri: string, userResponse: Array<object>) => {

    const postSubmitEvent = {
        attributes: {
            resp_id: respId
        },
        event_name: "submit_quiz_success",
        event_type: "api",
        event_timestamp: new Date().getTime(),
        page_uri: pageUri,
    }
    postAppEvent({ sessionId: sessionId, inAppEvent: [postSubmitEvent] });
    handleQuizSubmit(respId)

    if (quiz?.meta?.recoUrl != "") {
        const recoURL = quiz?.meta?.recoUrl === "/" ? "https://a.tangent.ai/shopify-builder/app/product-recommendation.html" : quiz?.meta?.recoUrl;

        const customRecoUrl = fetchCustomRedirectionIfAny(quiz, userResponse);
        const urlToRedirect = (customRecoUrl != null) ? customRecoUrl : recoURL;

        if (urlToRedirect) {
            window.location.href = addQueryParams(urlToRedirect, "resp_id", respId);
        }
    }
}

export default quizRedirect;